<div class="dialog-header">
    <h2 matDialogTitle>{{data.title}}</h2>
    <button mat-icon-button type="button" matTooltip="Close" id="btnClose" class="inverse-button-no-border" (click)="cancel()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content align="center">
    <span>{{data.message}}</span>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button matTooltip="Ok" id="btnUpdate" class="regular-button" (click)="confirm()">
        <span>Ok</span>
    </button>
</mat-dialog-actions>
